import { Box, HStack, Square, Text, useColorModeValue } from '@ecoinvent/ui';

import { FlowsInput, FlowsOutput } from 'hooks/data/datasets/V4/flows/types';
import { DARK_SURFACE } from 'utilities/constants/colors';

type Props = {
  outputs: (FlowsInput | FlowsOutput)[];
};

const LEGEND = [
  { color: '#5CD496', label: 'Inputs' },
  { color: '#4299E1', label: 'Dataset' },
  { color: '#9F7AEA', label: 'Outputs' },
];

const GraphLegend = ({ outputs: _ }: Props) => {
  const legendTextColor = useColorModeValue('gray.600', 'rgba(255,255,255,0.92)');
  const legendBg = useColorModeValue('white', DARK_SURFACE);

  return (
    <Box
      position="absolute"
      bottom={4}
      left={4}
      zIndex={10}
      pointerEvents="none"
      bg={legendBg}
      borderRadius="md"
      px={3}
      py={2}
      boxShadow="sm"
    >
      <HStack spacing={3} align="center">
        {LEGEND.map(({ color, label }) => (
          <HStack key={label} spacing={1} align="center">
            <Square size="12px" bg={color} borderRadius="sm" />
            <Text fontSize="xs" color={legendTextColor}>
              {label}
            </Text>
          </HStack>
        ))}
      </HStack>
    </Box>
  );
};

export default GraphLegend;
